import React from 'react';
import styles from './target-audience.module.scss';
import {
  NicheCarwashSvg,
  NicheBeautySvg,
  NichePhotoSvg,
  NicheMedicalSvg,
} from 'shared/svg';

const iconColors = ['green', 'blue', 'orange', 'purple', 'pink', 'teal'];

const niches = [
  { icon: <NicheBeautySvg />, label: 'Салоны красоты и парикмахерские' },
  { icon: <NicheBeautySvg />, label: 'Барбершопы' },
  { icon: <NicheBeautySvg />, label: 'Маникюрные студии' },
  { icon: <NicheMedicalSvg />, label: 'Косметологии и SPA' },
  { icon: <NicheCarwashSvg />, label: 'Автомойки и детейлинг' },
  { icon: <NichePhotoSvg />, label: 'Фотостудии' },
];

export const TargetAudience: React.FC = () => {
  return (
    <div className={styles.target_audience_outer}>
      <div className={styles.target_audience}>
        <h2 className={styles.target_audience__title}>Кому подходит BookUp</h2>
        <div className={styles.target_audience__grid}>
          {niches.map((niche, index) => (
            <div
              key={index}
              className={`${styles.niche_card} ${styles[`niche_card--${iconColors[index]}`]}`}
            >
              <div className={styles.card__icon_wrapper}>{niche.icon}</div>
              <div className={styles.card__label}>{niche.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
